import React from 'react';
import PhoneInput from 'react-phone-input-2';

function FormattedPhoneInput(props) {
  const { country, fieldName, index } = props;

  async function handlePhoneNumbers(index, value, data) {
    let rawPhone = value.slice(data.dialCode.length);
    let code = value.split(`${rawPhone}`)[0];
    let fullNumber = `+${code}-${rawPhone}`;

    if (value.includes("+")) {
      code = value.split(`${rawPhone}`)[0];
      code = code.replace("+", "");
    }

    const countryCode = parseInt(code);
    while (rawPhone.startsWith("0")) {
      rawPhone = rawPhone.substring(1);
    }
    fullNumber = `+${countryCode}-${rawPhone}`;

    if (index !== undefined) {
      props.onPhoneNumberChange(index, value, fullNumber);
      await props.onPhoneNumberValidation(index, fieldName, fullNumber);
    } else {
      props.onPhoneNumberChange(value, fullNumber);
      await props.onPhoneNumberValidation(fieldName, fullNumber);
    }
  }

  return (
    <div className={"phone-input-container"}>
    <PhoneInput
        id={'phone-input'}
        key={props.index}
        country={country}
        value={props.phoneNumber}
        onChange={(value, data) => handlePhoneNumbers(props.index, value, data)}
        inputStyle={{ width: '100%'}}
        fieldName={""||props.fieldName}
        specialLabel=""
      />
    </div>
  );
}

export default FormattedPhoneInput;
